import { render } from "./AppCollapsingCardWithButtons.vue?vue&type=template&id=47025f2c&scoped=true&ts=true"
import script from "./AppCollapsingCardWithButtons.vue?vue&type=script&lang=ts"
export * from "./AppCollapsingCardWithButtons.vue?vue&type=script&lang=ts"

import "./AppCollapsingCardWithButtons.vue?vue&type=style&index=0&id=47025f2c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47025f2c"]])

export default __exports__